/**
 * Breadcrumb labels, paths, and schema copy for event category pages.
 */
export const eventCategorySeo = {
  wedding: {
    path: "/wedding-events",
    breadcrumbLabel: "Wedding Events",
    serviceName: "Wedding planning and wedding event management",
    serviceDescription:
      "End-to-end wedding planning, décor, production, and on-ground coordination for couples and families in Ahmedabad, Gujarat, and across India — from mehndi and sangeet to reception and destination weddings.",
    eventName: "Wedding celebrations — planning and production in Ahmedabad & Gujarat",
    eventDescription:
      "Professional wedding event services including stage, lighting, sound, LED, artist coordination, and guest hospitality for celebrations in Gujarat and India.",
  },
  corporate: {
    path: "/corporate-events",
    breadcrumbLabel: "Corporate Events",
    serviceName: "Corporate event planning and conference management",
    serviceDescription:
      "Corporate conferences, product launches, awards, exhibitions, and internal events with AV, staging, branding, and delegate management for businesses in Ahmedabad, Gujarat, and India-wide programmes.",
    eventName: "Corporate events — conferences and launches in Ahmedabad",
    eventDescription:
      "Corporate event organizer services for professional programmes, branded staging, and hybrid or virtual formats across Gujarat and India.",
  },
  social: {
    path: "/social-events",
    breadcrumbLabel: "Social Events",
    serviceName: "Social and family celebration planning",
    serviceDescription:
      "Ring ceremonies, baby showers, anniversaries, festivals, and private gatherings with décor, catering coordination, and entertainment in Ahmedabad and Gujarat.",
    eventName: "Social celebrations — family events in Gujarat",
    eventDescription:
      "Planning and execution for social milestones with hospitality-first layouts and production support.",
  },
  other: {
    path: "/other-events",
    breadcrumbLabel: "Other Events",
    serviceName: "Specialty and public event management",
    serviceDescription:
      "Fashion shows, sports days, mall activations, institutional programmes, and promotional events with staging, crowd management, and artist coordination in Ahmedabad and Gujarat.",
    eventName: "Specialty events — public and promotional programmes",
    eventDescription:
      "Flexible event management for non-standard formats, protocols, and audience experiences.",
  },
  concert: {
    path: "/concert-events",
    breadcrumbLabel: "Concerts & Live Shows",
    serviceName: "Concert production and live entertainment",
    serviceDescription:
      "Concerts, DJ nights, celebrity shows, and college festivals with stage, truss, sound, LED, SFX, and security in Gujarat and India.",
    eventName: "Live concerts and entertainment shows — Gujarat",
    eventDescription:
      "Concert organizer services with technical production, backstage, and audience management.",
  },
};
